import { render, staticRenderFns } from "./my-deal.vue?vue&type=template&id=f0b3b780&scoped=true&"
import script from "./my-deal.vue?vue&type=script&lang=js&"
export * from "./my-deal.vue?vue&type=script&lang=js&"
import style0 from "./my-deal.vue?vue&type=style&index=0&id=f0b3b780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b3b780",
  null
  
)

component.options.__file = "my-deal.vue"
export default component.exports